import * as React from "react"

function FBLogo(props) {
  return (
    <svg
      viewBox="0 0 61 61"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <path
        d="M57.378 0H3.352A3.352 3.352 0 000 3.352v54.026a3.353 3.353 0 003.352 3.354h29.086V37.213h-7.914v-9.167h7.914v-6.76c0-7.843 4.789-12.116 11.787-12.116 3.355 0 6.232.251 7.071.36v8.198l-4.854.002c-3.805 0-4.539 1.809-4.539 4.462v5.851h9.078l-1.187 9.166h-7.892v23.52h15.475a3.355 3.355 0 003.355-3.351V3.35A3.352 3.352 0 0057.378 0z"
        fill="#8d8d8d"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default FBLogo